module.exports = __webpack_public_path__ + "static/media/edit.f86035f9.svg";